module.exports = __webpack_public_path__ + "img/1080_19.7ed5a0b4.jpg";